import { render, staticRenderFns } from "./v-alert-global.vue?vue&type=template&id=5f22d756&scoped=true&"
import script from "./v-alert-global.vue?vue&type=script&lang=js&"
export * from "./v-alert-global.vue?vue&type=script&lang=js&"
import style0 from "./v-alert-global.vue?vue&type=style&index=0&id=5f22d756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22d756",
  null
  
)

export default component.exports